// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "ed2b546e9dead0ba","396": "c3e4adef6c10cd74","460": "76a692b19cf0dd27","917": "0218b2d506ec1bef","985": "6806b46bb47c1ede",}[chunkId] + ".chunk.js"
}